var _tspan;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnScreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "yyopf17kba"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 719",
    style: {
      fill: "#3162d2"
    },
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 739",
    width: 54,
    height: 54,
    rx: 12,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 410"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 373",
    style: {
      clipPath: "url(#yyopf17kba)"
    },
    transform: "translate(15 10)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 701",
    d: "M2.2 0h19.6c.523.229.612.66.612 1.18q-.014 8.511 0 17.023a.913.913 0 0 1-.284.767l1.88 3.9v.43c-.031.031-.075.057-.091.094a.925.925 0 0 1-.928.607L.9 24a1.15 1.15 0 0 1-.221-.038C.313 23.886.149 23.6 0 23.3v-.516l.079-.149 1.694-3.473a.247.247 0 0 0-.032-.305.747.747 0 0 1-.136-.419Q1.595 9.6 1.6.753A.945.945 0 0 1 1.653.49C1.735.215 1.968.1 2.2 0m.208.8v17.593h8.015a1.073 1.073 0 0 0 .066-.128 1.585 1.585 0 0 1 2.965-.053.266.266 0 0 0 .3.194q3.808-.008 7.615 0h.215V.8zm11.117 18.4a1.224 1.224 0 0 1-.631.883.761.761 0 0 0-.52.962.914.914 0 0 1 0 .117.4.4 0 1 1-.8 0c0-.211-.01-.422 0-.632.009-.141-.046-.189-.173-.239a1.53 1.53 0 0 1-.891-.871.283.283 0 0 0-.31-.22c-2.343.005-4.687.021-7.03-.012a.753.753 0 0 0-.8.541 115.835 115.835 0 0 1-1.471 3.056c-.142.286-.157.423.235.423q10.862-.013 21.724 0c.286 0 .414-.064.243-.411q-.827-1.684-1.638-3.376a.341.341 0 0 0-.364-.222c-2.257.007-4.515 0-6.773 0h-.794m-2.332-.414a.767.767 0 0 0 .791.816.8.8 0 0 0 .793-.809.765.765 0 0 0-.834-.783.735.735 0 0 0-.749.776",
    style: {
      fill: "#3162d2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 702",
    d: "M36.708 19.015v-5.477c0-.374.1-.469.465-.452.219.01.317.155.334.507.7.3 1.416.6 2.126.9.3.126.595.242.636.639a.746.746 0 0 1-.428.79c-.775.329-1.553.653-2.325.976v2.166c.306.023.6.044.9.068a6.594 6.594 0 0 1 3.293.988 2.065 2.065 0 0 1 .906 1.217.224.224 0 0 0 .144.134.341.341 0 0 1 .317.355.369.369 0 0 1-.319.407 1.211 1.211 0 0 1-.21.008H26.074c-.173 0-.358.036-.489-.138a.4.4 0 0 1 .256-.652 1.723 1.723 0 0 1 .257-.009h5.225c.167 0 .224-.048.278-.212a2.324 2.324 0 0 1 1.156-1.3 6.035 6.035 0 0 1 2.234-.707c.561-.067 1.123-.138 1.716-.211m.806-3.027v.033l.033-.028c.237-.093.476-.183.711-.28.353-.145.7-.3 1.1-.463l-1.843-.784zm-5.121 5.445H41.8a2.054 2.054 0 0 0-1.073-.961 7.463 7.463 0 0 0-2.672-.577c-.75-.038-1.506.009-2.258.041a6.44 6.44 0 0 0-2.189.472 2.031 2.031 0 0 0-1.213 1.025",
    transform: "translate(-22.312 -11.445)",
    style: {
      fill: "#3162d2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 703",
    d: "M28.772 96.344a1.441 1.441 0 0 1 1.374.2 1.573 1.573 0 0 1 .494.8 3.522 3.522 0 0 0 .292.5 1.372 1.372 0 0 1-1.177 1.969c-1.006.028-2.013 0-3.02 0a1.4 1.4 0 0 1-.556-2.615.226.226 0 0 0 .088-.129 1.363 1.363 0 0 1 1.247-1.229 1.422 1.422 0 0 1 1.257.5m-.524 2.677v.005c.468 0 .937-.01 1.4 0a.605.605 0 0 0 .581-.4.584.584 0 0 0-.187-.66.538.538 0 0 1-.158-.332.622.622 0 0 0-.989-.481c-.312.211-.513.16-.7-.18a.592.592 0 0 0-1.128.308c.021.351.047.432-.417.6a.583.583 0 0 0-.379.633.635.635 0 0 0 .548.5c.475-.017.952 0 1.428 0",
    transform: "translate(-22.285 -83.83)",
    style: {
      fill: "#3162d2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 704",
    d: "M124.214 109.461c-.476 0-.953.011-1.428 0a1.383 1.383 0 0 1-1.3-1.243 1.438 1.438 0 0 1 .67-1.373.581.581 0 0 0 .169-.313 1.322 1.322 0 0 1 1.026-1.017 1.424 1.424 0 0 1 1.3.337.382.382 0 0 0 .272.061 1.4 1.4 0 0 1 1.721 1.075.407.407 0 0 0 .1.17 1.354 1.354 0 0 1 .247 1.4 1.191 1.191 0 0 1-1.035.86c-.578.044-1.161.01-1.742.01v.041m.055-.8h1.357a.623.623 0 0 0 .607-.371.656.656 0 0 0-.16-.691.581.581 0 0 1-.174-.305.635.635 0 0 0-1.012-.5c-.292.172-.481.137-.646-.17a.625.625 0 0 0-.525-.347.594.594 0 0 0-.639.665c0 .391-.044.477-.345.545a.617.617 0 0 0-.452.669.608.608 0 0 0 .609.505h1.38",
    transform: "translate(-106.296 -92.263)",
    style: {
      fill: "#3162d2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 705",
    d: "M121.622 36.224a.02.02 0 0 1 .033.006l-.033.028v-.033",
    transform: "translate(-106.419 -31.682)",
    style: {
      fill: "#3162d2"
    }
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(14 46)",
    style: {
      fontSize: 10,
      fontFamily: "Pretendard-Bold,Pretendard",
      fontWeight: 700,
      letterSpacing: "-.001em",
      fill: "#3162d2"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC2A4\uD06C\uB9B0"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnScreen);
export default __webpack_public_path__ + "static/media/icn_screen.aad6e319b30aae3198b06aac29eb5ee1.svg";
export { ForwardRef as ReactComponent };